export default Object.freeze({
  FREE: 'free',
  SMART: 'smart',
  PRO: 'pro',
  PROADMIN: 'proadmin'
})
